export const getOriginFromUrl = () => {
  const searchParams = new URL(self.location.href).searchParams;
  return searchParams.get('origin') || '';
};
